import { ClienteModel } from './../../../model/cliente/cliente.model';
import { FormControl } from '@angular/forms';
import { RoleModel } from './../../../model/usuario/role.model';
import { UsuarioModel } from './../../../model/usuario/usuario.model';
import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configurar-permissao',
  templateUrl: './configurar-permissao.component.html',
  styleUrls: ['./configurar-permissao.component.scss']
})
export class ConfigurarPermissaoComponent implements OnInit {

  public usuarioId;
  public usuario = {} as UsuarioModel;
  public usuarios: UsuarioModel[];
  public role = {} as RoleModel;
  public roles: RoleModel[];
  public totalrole = {} as RoleModel;
  public totalroles: RoleModel[];
  public cliente = {} as ClienteModel;
  public clientes: ClienteModel[];
  public qtdRoles;
  public qtdClientes;
  public queryField = new FormControl();
  public queryFieldCliente = new FormControl();
  public busca = false;
  public buscaCliente = false;

  constructor(
    private authService: AuthenticationService,
    private permissionService: PermissoesService,
    private router: Router,
    private route: ActivatedRoute) {
      this.route.params.subscribe(params => this.usuarioId = params['id']);
     }

  ngOnInit() {
    this.getUsuario(this.usuarioId);
    this.listRolesUsuarios(this.usuarioId);
  }

  getUsuario(id: number) {
    this.permissionService.getUserUnico(id).subscribe( data => {
      this.usuario = data;
    }, err => {
      console.error(err);
    });
  }

  listRolesUsuarios(id: number) {
    this.permissionService.getRolesUsuario(id).subscribe(data => {
      this.roles = data;
    }, err => {
      console.error(err);
    });
  }

  listarRoles() {
    this.permissionService.getRoles().subscribe(data => {
      this.totalroles = data;
    }, err => {
      console.error(err);
    });
  }

  getSearchRole(name: String) {
    this.permissionService.getSearchRole(name).subscribe( data => {
      this.totalroles = data;
      this.qtdRoles = data.length;
    }, err => {
      console.error(err);
    });
  }

  buscarCliente(nome: String) {
    this.permissionService.getSearchCliente(nome).subscribe( data => {
      this.clientes = data;
      this.qtdClientes = data.length;
    }, err => {
      console.error(err);
    });
  }

  onSearch() {
    this.busca = true;
    if (this.queryField.value === '') {
      this.getSearchRole(this.queryField.value);
    } else {
      this.getSearchRole(this.queryField.value);
    }
  }

  onSearchCliente() {
    this.buscaCliente = true;
    if (this.queryFieldCliente.value === '') {
      this.buscarCliente(this.queryFieldCliente.value);
    } else {
      this.buscarCliente(this.queryFieldCliente.value);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/usuario/configurar-permissao/configurar-permissao.component.ts